import { toastVariant, useToast } from '__components/ToastProvider';
import { useTranslation } from 'react-i18next';
import AxiosService from 'services/AxiosService';
import { useCallback, useRef, useState } from 'react';
import {
  postAutomationExecutionSkipAndResume,
  type AutomationExecution,
} from '@kizen/api/automation';

export const useSkipExecutionStepModal = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const [showToast] = useToast();
  const [execution, setExecution] =
    useState<SnakeToCamelCase<AutomationExecution> | null>(null);

  const onSuccessRef = useRef(onSuccess);
  onSuccessRef.current = onSuccess;

  const showSkipStepModal = useCallback(
    (data: SnakeToCamelCase<AutomationExecution>) => {
      setExecution(data);
    },
    []
  );

  const onHide = useCallback(() => {
    setExecution(null);
  }, []);

  const onConfirm = useCallback(
    async (branchPath?: 'yes' | 'no') => {
      try {
        await postAutomationExecutionSkipAndResume(
          AxiosService,
          execution!.id,
          {
            skip_step_id: execution!.pausedOnStep!.id,
            continue_with_branch: branchPath,
          }
        );
        showToast({
          variant: toastVariant.SUCCESS,
          message: t('Agentic workflow resumed successfully'),
        });

        onHide();
        onSuccessRef.current?.();
      } catch (error) {
        showToast({
          variant: toastVariant.FAILURE,
          message: t('Error occurred - could not resume agentic workflow'),
        });
      }
    },
    [onHide, showToast, execution, t]
  );

  return {
    show: !!execution,
    skipStepModalProps: {
      onConfirm,
      onHide,
      isCondition: execution?.pausedOnStep?.type === 'condition',
      stepLabel: execution?.pausedOnStep?.label,
      isBranching: execution?.pausedOnStep?.branchingStep,
    },
    showSkipStepModal,
  };
};
